import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../../../_services/auth.service';
import { AppComponent } from 'src/app/app.component';
import { NavService } from 'src/app/_services/nav.service';
import { Company } from '../../../../models/company.model';
import { BehaviorSubject } from 'rxjs';
import {
  NgbPaginationModule,
  NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { PopupEditUserComponent } from './edit-user-popup.component';
import { CompanyService } from 'src/app/_services/company.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { ToastrService } from 'src/app/_services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { PopupDeleteComponent } from '../../informes/descargas/delete-popup.component';
import { LicenseService } from 'src/app/_services/license.service';
import { License } from 'src/models/license.model';
import { PopupCreateUserComponent } from './create-user-popup.component';

@Component({
  selector: 'compañia-detail',
  templateUrl: './compañia-detail.component.html',
  styleUrls: ['./compañia-detail.component.css'],
})
export class CompañiaDetailComponent implements OnInit {
  page = 1;
  pageSize = 7;
  collectionSize = 0;
  users: any[] = [];

  pendingPage = 1;
  pendingPageSize = 7;
  pendingCollectionSize = 0;
  pendingUsers: any[] = [];

  searchText = '';
  companyId: number;
  currentCompany: any;
  isSuperAdmin: boolean;
  closeResult = '';
  isCompanyAdmin: boolean;

  allCompanies: any[] = [];
  selectedCompany: any;

  companies: Company[] = [];

  isLoading: boolean = true;
  isLoading2: boolean = true;

  modalRef?: BsModalRef;
  protected ngbModalRef: NgbModalRef;

  selectedFile: File | null = null;
  selectedFileCertificate: File | null = null;

  formData = new FormData();

  selectedCsvFile: File | null = null;

  newCompany = {
    Name: null,
    Sector: null,
    WebAddress: null,
    Address: null,
    Phone: null,
    Description: null,
    Email: null,
    ApplicationId: null,
    Certificate: null,
    WebDomain: null,
    CertificatePassword: null,
    FileLogo: null,
    FileCertificate: null,
    Language: null,
    DataTypes: null,
  };

  license: License = null;
  canEditLicense: boolean = false;

  langs;
  selectedLang;

  dataTypes: any[] = [];

  maintenanceMessage: string;

  // tslint:disable-next-line: max-line-length
  constructor(
    private authService: AuthService,
    private appComponent: AppComponent,
    private navService: NavService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    public companyService: CompanyService,
    private modalServicee: BsModalService,
    public toastrService: ToastrService,
    private translateService: TranslateService,
    public licenseService: LicenseService
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    this.appComponent.setTitle('Company');
    this.isLoading = true;
    this.isLoading2 = true;
    this.getLangs();
    this.authService.isSuperAdmin().subscribe((res) => {
      this.isSuperAdmin = !!res;
    });
    this.authService.isAdmin().subscribe((res) => {
      this.isCompanyAdmin = !!res;
    });
    this.route.paramMap.subscribe((params) => {
      this.companyId = +params.get('id');
      this.companyService.getDataTypes(this.companyId).subscribe((res) => {
        this.mapDataTypes(res?.body);
      });
      this.licenseService.isAuthorized(this.companyId).subscribe((res) => {
        this.canEditLicense = !!res;
        if (this.canEditLicense) {
          this.licenseService
            .getLicenseByCompany(this.companyId)
            .subscribe((res) => {
              if (res) {
                this.license = res;
              } else {
                this.license = new License();
                this.license.companyId = this.companyId;
              }
            });
        }
      });
      this.companyService.getCompanyById(this.companyId).subscribe((res) => {
        this.currentCompany = res.body;
        this.newCompany.Name = this.currentCompany.name;
        this.newCompany.WebAddress = this.currentCompany.url;
        this.newCompany.Address = this.currentCompany.address;
        this.newCompany.Phone = this.currentCompany.phone;
        this.newCompany.Description = this.currentCompany.description;
        this.newCompany.Email = this.currentCompany.email;
        this.newCompany.ApplicationId = this.currentCompany.appId;
        this.newCompany.Certificate = this.currentCompany.tenant;
        this.newCompany.WebDomain = this.currentCompany.domain;
        this.newCompany.CertificatePassword =
          this.currentCompany.certificateSecret;
        this.newCompany.Language = this.currentCompany.language;
        this.newCompany.DataTypes =
          this.currentCompany?.sensitiveInformationTypes?.map((dt) => ({
            id: dt.id,
            label: dt.name,
          }));
        console.log(this.newCompany.DataTypes);
        console.log(this.dataTypes);
        this.refreshUsers();
        if (this.isSuperAdmin) {
          this.refreshPendingUsers();
        }
        if (this.companyId === 1) {
          this.getMaintenanceMessage();
        }
      });
    });

    this.companyService
      .getAllCompanies(this.page, 1000, '')
      .subscribe((res) => {
        this.companies = res.body;
      });

    this.selectedNavItem({ parent: 'Administración', child: 'Compañias' });
  }

  compareFn(item1: any, item2: any): boolean {
    return item1 && item2 ? item1.id === item2.id : item1 === item2;
  }

  mapDataTypes(dataTypes) {
    this.dataTypes = dataTypes.map((dt) => {
      return {
        id: dt.id,
        label: dt.name,
      };
    });
  }

  mapDataTypesCompany(dataTypes) {
    return dataTypes.map((dt) => {
      return {
        id: dt.id,
        label: dt.name,
      };
    });
  }

  getLangs() {
    this.companyService.getLangs().subscribe((langs) => {
      if (langs.body) {
        this.langs = langs.body;
      }
    });
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }

  getImgPath(path) {
    return path.match(/images\/(.*)/)[0];
  }

  refreshUsers() {
    this.isLoading = true;
    this.companyService
      .getUserListByCompany(this.companyId, this.page, this.pageSize)
      .subscribe((res) => {
        this.users = res.body['results'];
        this.collectionSize = res.body['total'];
        this.isLoading = false;
      });
  }

  refreshPendingUsers() {
    this.isLoading2 = true;
    this.companyService
      .getPendingUsersList(this.pendingPage, this.pendingPageSize)
      .subscribe((res) => {
        this.pendingUsers = res.body['results'];
        this.pendingCollectionSize = res.body['total'];
        this.isLoading2 = false;
      });
  }

  createUser() {
    this.ngbModalRef = this.modalService.open(PopupCreateUserComponent, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
    });

    this.ngbModalRef.componentInstance.companies = this.companies['results'];

    this.ngbModalRef.result.then(
      (result) => {
        this.refreshUsers();
      },
      (err) => {
        window.console.log('err');
      }
    );
  }

  editUser(user) {
    this.ngbModalRef = this.modalService.open(PopupEditUserComponent, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
    });

    const userToEdit = JSON.parse(JSON.stringify(user));

    this.ngbModalRef.componentInstance.companies = this.companies['results'];
    this.ngbModalRef.componentInstance.user = userToEdit;
    this.ngbModalRef.componentInstance.currentCompany = this.companyId;

    this.ngbModalRef.result.then(
      (result) => {
        this.refreshUsers();
      },
      (err) => {
        window.console.log('err');
      }
    );
  }

  editPendingUser(user) {
    this.ngbModalRef = this.modalService.open(PopupEditUserComponent, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
    });
    this.ngbModalRef.componentInstance.companies = this.companies['results'];
    this.ngbModalRef.componentInstance.user = user;
    this.ngbModalRef.componentInstance.currentCompany = this.companyId;

    this.ngbModalRef.result.then(
      (result) => {
        result.idStatus = 1;
        result.statusId = 1;
        this.authService.updateUser(user.id, result).subscribe(
          (res) => {
            this.toastrService.success(
              this.translateService.instant('alert.successEdit')
            );
            this.refreshPendingUsers();
          },
          (error) => {
            this.toastrService.error(
              this.translateService.instant('alert.error')
            );
          }
        );
      },
      (err) => {
        window.console.log('err');
      }
    );
  }

  deleteUser(user) {
    this.ngbModalRef = this.modalService.open(PopupDeleteComponent, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
    });
    this.ngbModalRef.componentInstance.isDeleteUser = true;
    this.ngbModalRef.componentInstance.user = user;
    this.ngbModalRef.result.then(
      (result) => {
        this.authService.deleteUser(user.id).subscribe(
          (res) => {
            this.toastrService.success(
              this.translateService.instant('alert.successEdit')
            );
            this.refreshUsers();
          },
          (err) => {
            this.toastrService.error(
              this.translateService.instant('alert.error')
            );
          }
        );
      },
      (err) => {
        window.console.log('err');
      }
    );
  }

  deletePendingUser(user) {
    this.ngbModalRef = this.modalService.open(PopupDeleteComponent, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
    });
    this.ngbModalRef.componentInstance.isDeleteUser = true;
    this.ngbModalRef.componentInstance.user = user;
    this.ngbModalRef.result.then(
      (result) => {
        this.authService.deleteUser(user.id).subscribe(
          (res) => {
            this.toastrService.success(
              this.translateService.instant('alert.successEdit')
            );
            this.refreshPendingUsers();
          },
          (err) => {
            this.toastrService.error(
              this.translateService.instant('alert.error')
            );
          }
        );
      },
      (err) => {
        window.console.log('err');
      }
    );
  }

  save() {
    this.newCompany.Name && this.formData.append('Name', this.newCompany.Name);
    this.newCompany.WebAddress &&
      this.formData.append('WebAddress', this.newCompany.WebAddress);
    this.newCompany.Address &&
      this.formData.append('Address', this.newCompany.Address);
    this.newCompany.Phone &&
      this.formData.append('Phone', this.newCompany.Phone);
    this.newCompany.Description &&
      this.formData.append('Description', this.newCompany.Description);
    this.newCompany.Email &&
      this.formData.append('Email', this.newCompany.Email);
    this.newCompany.ApplicationId &&
      this.formData.append('ApplicationId', this.newCompany.ApplicationId);
    this.newCompany.Certificate &&
      this.formData.append('Certificate', this.newCompany.Certificate);
    this.newCompany.WebDomain &&
      this.formData.append('WebDomain', this.newCompany.WebDomain);
    this.newCompany.CertificatePassword &&
      this.formData.append(
        'CertificatePassword',
        this.newCompany.CertificatePassword
      );
    this.newCompany.Language &&
      this.formData.append(
        'IdLanguage',
        this.langs?.find((lang) => lang.langCode === this.newCompany.Language)
          .id
      );

    console.log(this.newCompany.DataTypes);

    // Agregamos los archivos si existen
    if (this.newCompany.FileLogo) {
      this.formData.append(
        'FileLogo',
        this.newCompany.FileLogo,
        this.newCompany.FileLogo.name
      );
    }

    if (this.newCompany.FileCertificate) {
      this.formData.append(
        'FileCertificate',
        this.newCompany.FileCertificate,
        this.newCompany.FileCertificate.name
      );
    }

    this.companyService
      .saveCompany(this.currentCompany.id, this.formData)
      .subscribe(
        (res) => {
          if (this.newCompany.DataTypes) {
            this.companyService
              .setDataTypes(this.newCompany?.DataTypes, this.currentCompany.id)
              .subscribe();
          }
          this.toastrService.success(
            this.translateService.instant('alert.successEdit')
          );
          if (this.selectedCsvFile) {
            this.companyService
              .importCsv(this.selectedCsvFile, this.currentCompany.id)
              .subscribe((response) => {});
          }
        },
        (err) => {
          this.toastrService.error(
            this.translateService.instant('alert.error')
          );
        }
      );
  }

  compareUsernameWithMicrosoftGuid(username: string) {
    return username;
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0] as File;
    this.newCompany.FileLogo = this.selectedFile;
  }

  onCsvSelected(event: any) {
    this.selectedCsvFile = event.target.files[0] as File;
  }

  onFileSelectedCertificate(event: any) {
    this.selectedFileCertificate = event.target.files[0] as File;
    this.newCompany.FileCertificate = this.selectedFileCertificate;
  }

  getMaintenanceMessage() {
    this.companyService.getMaintenanceMessage().subscribe((res) => {
      if (res) {
        this.maintenanceMessage = res.message;
      }
    });
  }

  saveMaintenance() {
    if (!this.maintenanceMessage) {
      this.toastrService.error(
        this.translateService.instant('maintenanceEvents.enterMessage')
      );
      return;
    }
    this.companyService
      .saveMaintenanceMessage(this.maintenanceMessage)
      .subscribe(
        (res) => {
          this.toastrService.success(
            this.translateService.instant('alert.successEdit')
          );
        },
        (err) => {
          this.toastrService.error(
            this.translateService.instant('alert.error')
          );
        }
      );
  }

  deleteMaintenance() {
    this.companyService.deleteMaintenanceMessage().subscribe(
      (res) => {
        this.toastrService.success(
          this.translateService.instant('alert.successEdit')
        );
        this.maintenanceMessage = '';
      },
      (err) => {
        this.toastrService.error(this.translateService.instant('alert.error'));
      }
    );
  }

  downloadExcel() {
    this.companyService.downloadDepartmentsTemplate(this.companyId).subscribe(
      (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'template.csv';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      (error) => {
        console.error('Error downloading the file', error);
      }
    );
  }
}
